import * as ort from "onnxruntime-web";

let configured = false;

export function getOnnxRuntime(): typeof ort {
  if (!configured) {
    ort.env.wasm.wasmPaths = "/ort/";
    ort.env.wasm.numThreads = 1;
    ort.env.wasm.proxy = false;
    configured = true;
  }

  return ort;
}
